import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {WebhookSubscriptionHdrContainerModel} from '../../../../../models/aggregates/webhook';


@Injectable({
  providedIn: 'root'
})
export class WebhookSubscriptionService extends BaseApiTemplateService<WebhookSubscriptionHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'webhook-subscription';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'webhook-subscription';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'webhook-subscription';
    this.httpClient = http;
  }
}
